import {
  BodyXSmallTypography,
  Box,
  ButtonLink,
  Flex,
  InterZellerMediumFont,
} from '@npco/zeller-design-system'
import styled from 'styled-components'

export const ActionButton = styled(ButtonLink)`
  ${BodyXSmallTypography}
  ${InterZellerMediumFont}
  background: inherit;
  color: ${({ theme }) => theme.colors.WHITE};
  font-size: 12px;
  text-decoration: underline;
`

export const TooltipWrapper = styled(Flex)`
  display: none;
  position: block;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.MD}) {
    display: unset;
    left: 0;
    padding-left: 12px;
    padding-top: 16px;
    position: absolute;
  }
`

export const TooltipContentWrapper = styled(Flex)`
  ${InterZellerMediumFont}
  flex-direction: column;
  font-size: 12px;
  text-align: center;
  width: 180px;
`

export const TooltipTrigger = styled(Box)`
  &:hover {
    cursor: pointer;
  }
`
